export const QUERY_STATEMENTS = "QUERY_STATEMENTS";
export const QUERY_STATEMENT = "QUERY_STATEMENT";
export const QUERY_STATEMENT_ENTRIES = "QUERY_STATEMENT_ENTRIES";
